import {useQuery} from '@tanstack/react-query'
import {useAccessToken, useCommerceApi} from '@salesforce/commerce-sdk-react'
import CustomApi from './use-custom-api'

const useContentAsset = (contentAssetId) => {
    const {getTokenWhenReady} = useAccessToken()
    const customApi = new CustomApi()
    const api = useCommerceApi()
    const {proxy} = api.shopperExperience.clientConfig

    const fetchContentAssetWithId = async (contentAssetId) => {
        const token = await getTokenWhenReady()
        const apiName = 'content-asset'
        const endpointPath = '/'
        const parameters = {
            c_contentAssetId: contentAssetId
        }
        const response = await customApi.get(token, apiName, endpointPath, parameters, proxy)

        return response
    }

    return useQuery({
        queryKey: ['use-content-asset', contentAssetId],
        queryFn: () => fetchContentAssetWithId(contentAssetId),
        enabled: !!contentAssetId,
        keepPreviousData: true,
        staleTime: 15 * 60 * 1000,
        cacheTime: 15 * 60 * 1000,
        refetchOnWindowFocus: false,
        refetchOnMount: false,
        refetchOnReconnect: false
    })
}

export default useContentAsset
